import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../lib/cart";
import { ShoppingBag } from "lucide-react";

export default function Boutique() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { totalItems } = useCart();

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="boutique-page">
      <section className="border-b-2 border-[#1A1A18]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-9">
            <div className="font-mono-label text-[#4A7A3D] mb-3">Boutique RWANA</div>
            <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95]">Porte le mouvement.</h1>
            <p className="font-quote text-2xl md:text-3xl text-[#4B4B48] mt-6 leading-snug max-w-2xl">
              « Les bénéfices financent l'impression du plaidoyer, les rencontres publiques et le travail éditorial. »
            </p>
          </div>
          <div className="md:col-span-3 md:text-right">
            <Link to="/panier" className="inline-flex items-center gap-2 border-2 border-[#1A1A18] px-5 py-3 font-mono-label hover:bg-[#1A1A18] hover:text-[#FAF8F3]" data-testid="boutique-cart-link">
              <ShoppingBag size={16} /> Panier ({totalItems})
            </Link>
          </div>
        </div>
      </section>

      <section className="border-b border-[#E0D8CE]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {loading ? (
            <p className="font-mono-label">CHARGEMENT…</p>
          ) : products.length === 0 ? (
            <p className="font-quote text-2xl text-[#4B4B48] py-16 text-center">La boutique est en cours de préparation.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {products.map((p) => (
                <Link key={p.slug} to={`/produit/${p.slug}`} className="block group card-shift border border-[#E0D8CE]" data-testid={`product-card-${p.slug}`}>
                  <div className="aspect-square overflow-hidden bg-[#F5EFEB]">
                    {p.image && <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" loading="lazy" />}
                  </div>
                  <div className="p-5 flex flex-col gap-2">
                    <span className="font-mono-label text-[#4A7A3D]">{p.category?.toUpperCase()}</span>
                    <h3 className="font-display text-2xl leading-tight group-hover:text-[#4A7A3D]">{p.name}</h3>
                    <div className="flex items-end justify-between mt-2">
                      <span className="font-display text-xl text-[#1A1A18]">{p.price}</span>
                      <span className="font-mono-label text-[#1A1A18] group-hover:text-[#4A7A3D]">Voir →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="bg-[#F5EFEB] border-b border-[#E0D8CE]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <div className="font-mono-label text-[#4A7A3D] mb-3">Comment commander&nbsp;?</div>
          <p className="text-lg text-[#4B4B48] leading-relaxed">
            Ajoute tes produits au panier, puis clique sur <strong>« Commander via WhatsApp »</strong>. Nous te contactons pour confirmer ta taille, ton mode de paiement (juice, espèces, virement) et la livraison à Maurice.
          </p>
        </div>
      </section>
    </div>
  );
}
